import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmMappingsMutationDtoSchema } from '../schema/AlgorithmMappingsMutationDto';
import {
  AlgorithmMappingsQueryDtoType,
  AlgorithmMappingsValidFormDataType,
} from '../schema/types';

const putAlgorithmMappings = (
  id: number,
  algorithmMappings: Partial<AlgorithmMappingsValidFormDataType>,
  headers?: HttpHeaders,
) =>
  apiClient
    .put<AlgorithmMappingsQueryDtoType>(
      expand(AlgorithmUrl.MAPPINGS, { id }),
      AlgorithmMappingsMutationDtoSchema.parse(algorithmMappings),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useMutateAlgorithmMappingsQuery = createApiMutationHook(
  ['algorithmMappings'],
  getMutationFn(undefined, putAlgorithmMappings),
);
